import React from 'react';

import { Button, Form, Modal } from 'antd';
import { Rule } from 'antd/es/form';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { SimHistoryInfo, SimHistoryResult } from 'domain/entities/SimulateEntity';
import { DialogIcon } from 'presentation/components/Modal/DialogIcon';
import { ConfirmModalProps } from 'presentation/components/Modal/Modal.type';
import { FormCheckBox } from 'presentation/components/form/FormCheckBox.component';
import { SIM_TYPE } from 'utilities/constants/COMMON';

interface props extends ConfirmModalProps {
    data?: SimHistoryResult;
}

export const CompareModalComponent = ({
    open,
    type = 'info',
    icon,
    okText = '比較する',
    cancelText = '戻る',
    onCancel,
    onOk,
    returnValue,
    okButtonProps,
    cancelButtonProps,
    data,
}: props) => {
    const [form] = Form.useForm();
    const [options, setOptions] = React.useState<OptionEntity[]>([]);
    const [btnDisabled, setBtnDisabled] = React.useState<boolean>(true);

    const RULE: Rule[] = [
        {
            message: '同時に比較できる履歴は2つまでです。',
            validator: (_, value) => {
                if (value && value.length > 2) {
                    return Promise.reject();
                }
                return Promise.resolve();
            },
        },
        {
            message: '',
            validator: (_, value) => {
                if (value && value.length != 2) {
                    return Promise.reject();
                }
                return Promise.resolve();
            },
        },
    ];

    React.useEffect(() => {
        if (data) {
            const optionSim = data?.history?.listSim?.map((item: SimHistoryInfo) => {
                return {
                    label:
                        (item.simulationTitle ? item.simulationTitle + '\n' : '') +
                        'キャッシュフローシミュレーション',
                    value: `${item.id}_${SIM_TYPE.HISTORY}`,
                };
            });
            const optionBeforeSim = data?.beforeSim?.map((item: SimHistoryInfo) => {
                return {
                    label: (item.name ? item.name + '\n' : '') + '購入申込時シミュレーション',
                    value: `${item.id}_${SIM_TYPE.BEFORE}`,
                };
            });
            const optionsConfirmSim: OptionEntity[] = data?.confirmSim?.map(
                (item: SimHistoryInfo) => {
                    return {
                        label: (item.name ? item.name + '\n' : '') + '確定シミュレーション',
                        value: `${item.id}_${SIM_TYPE.CONFIRM}`,
                    };
                },
            );
            setOptions([...optionSim, ...optionBeforeSim, ...optionsConfirmSim]);
        }
    }, [data]);

    const handleOk = () => {
        const selectedValue = form.getFieldValue('compare');
        if (selectedValue) {
            onOk && onOk(selectedValue);
            return;
        }
    };

    const valueChange = () => {
        form.validateFields({ validateOnly: true })
            .then(() => {
                setBtnDisabled(false);
            })
            .catch((err) => {
                setBtnDisabled(err.errorFields.length > 0);
            });
    };

    const handleCancel = () => {
        if (returnValue) {
            onCancel && onCancel(returnValue);
            return;
        }
        onCancel && onCancel();
    };

    return (
        <Modal
            width={327}
            open={open}
            footer={null}
            centered
            className="modal-info CU-059-01-container"
        >
            <Form form={form} onValuesChange={valueChange}>
                <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                    <div style={{ width: '100%' }} className="center-inside">
                        <DialogIcon type={type} icon={icon} />
                    </div>
                    <div
                        className="confirm-modal-2-title text-sm"
                        style={{ marginBottom: 8, marginTop: 32 }}
                    >
                        比較するキャッシュフローシミュレーション履歴を2つ選択してください。
                    </div>
                    <div
                        className="confirm-modal-2-description"
                        style={{ marginBottom: 12, color: '' }}
                    >
                        <FormCheckBox options={options} name="compare" rules={RULE} />
                    </div>
                    <Button
                        type="primary"
                        className="button-login-text"
                        {...okButtonProps}
                        disabled={btnDisabled}
                        style={{
                            width: '100%',
                            height: 48,
                            marginBottom: 12,
                            ...okButtonProps?.style,
                        }}
                        onClick={() => handleOk()}
                    >
                        {okText}
                    </Button>
                    <Button
                        type="link"
                        block
                        className="text-button-cancel"
                        style={{ width: '100%', height: 48 }}
                        onClick={() => handleCancel()}
                        {...cancelButtonProps}
                    >
                        {cancelText}
                    </Button>
                </section>
            </Form>
        </Modal>
    );
};
